import cx from 'classnames';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from '../CTACard/CTACard.css';

import {RegisterTestCardProps} from './RegisterTestCard.types';

import {registerTestCard} from './RegisterTestCard.css';

export const RegisterTestCard = ({columnSpan = 8, href = '/register'}: RegisterTestCardProps) => {
  return (
    <NextLink passHref href={href || '#'}>
      <a
        className={cx(
          css.root({variant: 'autoHeight'}),
          sprinkles({colSpan: columnSpan}),
          registerTestCard,
        )}>
        <div
          className={sprinkles({
            content: ['start'],
            display: 'flex',
            dir: 'col',
            gap: 24,
            h: 'full',
            items: 'start',
            p: [24, 24, 48],
            pos: 'relative',
          })}>
          <Text as="h2" variant="heading2" color="burgundy">
            Register your first TallyAge™ Test
          </Text>
          <Text as="p" variant="body" color="doveGray">
            {`Once you receive your TallyAge Test, register your kit and follow the instructions to
          submit your sample. You'll be one step closer to finding out your epigenetic age.`}
          </Text>
          <Button
            className={sprinkles({display: 'flex', mT: [0, 'auto']})}
            aria-hidden
            as="button"
            icon="ArrowRight"
            variant="primary">
            {' '}
            Register your test
          </Button>
        </div>
      </a>
    </NextLink>
  );
};
